import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

function Paginations({ currentPage, totalPages, onPageChange }) {
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  const startPages = [1, 2, 3];
  const endPages = [totalPages - 2, totalPages - 1, totalPages];

  let visiblePages = startPages;
  if (currentPage > 3 && currentPage < totalPages - 2) {
    visiblePages = [currentPage - 1, currentPage, currentPage + 1];
  } else if (currentPage >= totalPages - 2) {
    visiblePages = endPages;
  }

  const handlePageChange = (page) => {
    if (onPageChange) {
      onPageChange(page);
    }
  };


  return (
    <ul className="pagination justify-content-end mt-2">
      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
        <a className="page-link" href="#" onClick={() => handlePageChange(currentPage - 1)}>
          <FaChevronLeft />
        </a>
      </li>

      {visiblePages[0] > 1 && (
        <>
          <li className="page-item">
            <a className="page-link" href="#" onClick={() => handlePageChange(1)}>
              1
            </a>
          </li>
          {visiblePages[0] > 2 && (
            <li className="page-item disabled">
              <a className="page-link" href="#">
                ...
              </a>
            </li>
          )}
        </>
      )}

      { visiblePages.includes(0) ?
      
      visiblePages?.slice(1)?.map((page) => (
        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
          <a className="page-link" href="#" onClick={() => handlePageChange(page)}>
          
            {page}
          </a>
        </li>
      ))
      :
      visiblePages.map((page) => (
        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
          <a className="page-link" href="#" onClick={() => handlePageChange(page)}>
        
            {page}
          </a>
        </li>
      ))
    }

      {visiblePages[visiblePages.length - 1] < totalPages && (
        <>
          {visiblePages[visiblePages.length - 1] < totalPages - 1 && (
            <li className="page-item disabled">
              <a className="page-link" href="#">
                ...
              </a>
            </li>
          )}
          <li className="page-item">
            <a className="page-link" href="#" onClick={() => handlePageChange(totalPages)}>
              {totalPages}
            </a>
          </li>
        </>
      )}

      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
        <a className="page-link" href="#" onClick={() => handlePageChange(currentPage + 1)}>
          <FaChevronRight />
        </a>
      </li>
    </ul>
  );
}

export default Paginations;
